import React, { useEffect } from 'react';
import { useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { useHistory } from 'react-router-dom';
import { Spinner } from '@vwfs-bronson/bronson-react';
import { dashboardPagePath, landingPagePath } from 'components/navigation/paths';
import { useLogin } from 'auth';

export const LoginRedirect: React.FC = () => {
    const { isAuthenticated, logout } = useOidcAuthentication();
    const login = useLogin();
    const history = useHistory();

    const handleLogoutAndReLogin = async () => {
        const reLoginPagePath = window.location.origin + landingPagePath();
        await logout({ post_logout_redirect_uri: reLoginPagePath });
    };

    useEffect(() => {
        if (!isAuthenticated) {
            handleLogoutAndReLogin();
        } else {
            history.push(dashboardPagePath());
        }
    }, [history, isAuthenticated, login]);

    return <Spinner center />;
};
